__turbopack_context__.v({
  "section": "AppSection-module-scss-module__Zw7vcG__section",
});
